/**
 * Note this will only remove theme.scss styling, but will not allow the svelte
 * class to style it.
 *
 * @param {string} html - HTML string to be converted
 * @returns {string} - HTML string with data-sw-ds attribute added to all
 *   elements
 */
export const withDataSwDs = (html) => {
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  template.content
    .querySelectorAll("*")
    .forEach((el) => el.setAttribute("data-sw-ds", ""));
  return template.innerHTML;
};
